"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidURL = isValidURL;
function isValidURL(url) {
    return url.includes("https://") || url.includes("http://");
}
